import { detectPlatform } from "../../platform.js";
import type { Notifier } from "./NotificationScheduler.js";
import { capacitorNotifier } from "./adapters/capacitor.js";
import { tauriNotifier } from "./adapters/tauri.js";
import { webNotifier } from "./adapters/web.js";

function pickNotifier(): Notifier {
  switch (detectPlatform()) {
    case "tauri": return tauriNotifier;
    case "capacitor": return capacitorNotifier;
    default: return webNotifier;
  }
}

/**
 * Fire a diagnostic notification from Settings — immediately (`delayMs` omitted)
 * or after a delay, so the user can close the app and confirm the OS delivers it
 * in the background (the path that matters on Android). Throws on permission
 * denial / scheduling error so the caller can surface the reason. `background`
 * reports whether delivery survives the app being closed on this platform.
 */
export async function fireTestNotification(delayMs?: number): Promise<{ background: boolean }> {
  const notifier = pickNotifier();
  if (!notifier.sendTest) throw new Error("Test notifications aren't supported on this platform.");
  return notifier.sendTest(delayMs ? { atMs: Date.now() + delayMs } : {});
}
